"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPlugin = void 0;
const hasPlugin = (instance, plugin) => {
  const plugins = instance.getAvailablePlugins();
  return plugins.has(plugin);
};
exports.hasPlugin = hasPlugin;